import styled from 'styled-components';
import { acceptgreen, darkgrey } from 'styles/Colors';
import { SectionHeadlineWrapper } from '../SectionHeadline/SectionHeadlineStyles';
import { InningWrapper } from './InningSection/InningSectionStyles';

export const PlayListWrapper = styled.div`
  ${SectionHeadlineWrapper} {
    svg {
      cursor: pointer;
      top: -5px;
      position: absolute;
      right: 10px;
    }
  }
  .MuiPaper-root {
    padding: 6px 5px !important;
    overflow: auto;
    height: 100%;
    @media screen and (-webkit-min-device-pixel-ratio: 0) {
      overflow: hidden;
      &:hover {
        overflow-y: scroll;
        ${InningWrapper} {
          margin-right: -2px;
        }
      }
      &::-webkit-scrollbar {
        width: 2px;
      }
      &::-webkit-scrollbar-track {
        border-radius: 3.5px;
      }
      &::-webkit-scrollbar-thumb {
        background-image: linear-gradient(179deg, ${darkgrey}, rgba(65, 65, 65, 0.82));
        border-radius: 3.5px;
      }
    }
  }
`;
